import type { Percentage} from "@@/shared/percentage";
import { percentageZodSchema } from "@@/shared/percentage";
import type { Price } from "@@/shared/prices/price";
import { z } from "zod";

type VatBreakdownItem = {
    readonly _type: "VAT_BREAKDOWN_ITEM";
    readonly vatRate: Percentage;
    readonly vatAmount: number;
};

const vatBreakdownItemZodObject = z.object({
    _type: z.literal("VAT_BREAKDOWN_ITEM"),
    vatRate: percentageZodSchema,
    vatAmount: z.number().int(),
});
const vatBreakdownItemZodSchema: z.ZodSchema<VatBreakdownItem> =
    vatBreakdownItemZodObject;

type VatBreakdown = VatBreakdownItem[];
const vatBreakdownZodArray = z.array(vatBreakdownItemZodObject);
const vatBreakdownZodSchema: z.ZodSchema<VatBreakdown> = vatBreakdownZodArray;

const vatBreakdownFactory = (price: Price): VatBreakdown => {
    const vatBreakdownKeys = price.vatAmounts
        ? Object.keys(price.vatAmounts)
        : [];

    return vatBreakdownKeys.flatMap(p => {
        if (!price.vatAmounts) return [];
        const vatBreakdown = price.vatAmounts[p];
        return {
            _type: "VAT_BREAKDOWN_ITEM",
            vatRate: vatBreakdown.vatRate,
            vatAmount: vatBreakdown.vatAmount,
        };
    });
};

export {
    vatBreakdownFactory,
    vatBreakdownItemZodSchema,
    vatBreakdownZodSchema,
};
export type { VatBreakdown, VatBreakdownItem };
